export default __webpack_public_path__ + "static/Gears-9e7ba00f399ad178f465c6474c82b90b.svg";